import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const QuizResults = ({ recommendation, onBookInspection, onClose }) => {
  return (
    <Card className="max-w-2xl mx-auto">
      <CardHeader className={`${recommendation.bgColor} border-b-2 ${recommendation.borderColor}`}>
        <div className="flex items-center justify-center mb-4">
          <CheckCircle2 className={`w-16 h-16 ${recommendation.color}`} />
        </div>
        <CardTitle className="text-center text-3xl">{recommendation.title}</CardTitle>
      </CardHeader>
      <CardContent className="pt-8">
        <div className={`p-6 rounded-lg mb-6 border-2 ${recommendation.borderColor} ${recommendation.bgColor}`}>
          <p className="text-lg text-gray-700 mb-4">{recommendation.description}</p>
          <p className="font-semibold text-gray-900">{recommendation.action}</p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mb-6">
          <h4 className="font-bold text-gray-900 mb-3">Recommended Service:</h4>
          <p className="text-lg text-primary font-semibold mb-4">{recommendation.service}</p>
          
          <div className="space-y-2 text-sm text-gray-600">
            <p className="flex items-center">
              <CheckCircle2 className="w-4 h-4 text-primary mr-2" />
              Free, no-obligation inspection
            </p>
            <p className="flex items-center">
              <CheckCircle2 className="w-4 h-4 text-primary mr-2" />
              24/7 emergency service available
            </p>
            <p className="flex items-center">
              <CheckCircle2 className="w-4 h-4 text-primary mr-2" />
              Competitive pricing & financing options
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={onBookInspection}
            className="w-full bg-primary hover:bg-accent text-white text-lg py-6"
            data-testid="quiz-book-inspection-btn"
          >
            Book Your Free Inspection Now
          </Button>
          <Button
            onClick={onClose}
            variant="outline"
            className="w-full"
            data-testid="quiz-close-btn"
          >
            Close Quiz
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
